import {InboundWebhookDestination, InboundWebhookRequest, ProjectModel} from '@supermove/models';

export interface InboundWebhookDelivery {
  id: string;
  createdAt: string;
  updatedAt: string;
  uuid: string;
  inboundWebhookRequestId: number;
  inboundWebhookDestinationId: number;
  status: InboundWebhookDeliveryStatus;
  data: string;
  isExpired: boolean;

  inboundWebhookRequest: InboundWebhookRequest;
  inboundWebhookDestination: InboundWebhookDestination;

  dataPretty: string;
  project?: ProjectModel;
  deliveredAt?: string;
}

export enum InboundWebhookDeliveryStatus {
  Queued = 'queued',
  InProgress = 'in_progress',
  Success = 'success',
  Error = 'error',
}
